import mspStepButton from './msp_step_button'
import formReducer from './form_reducer'
import sendLinksButtonReducer from './send_links_button'
import bulkAssignInstallers from './bulk_assign_installers'

function reducer (state = {}, action) {
  return {
    mspData: mspStepButton(state.mspData, action),
    form: formReducer(state.form, action),
    send_links: sendLinksButtonReducer(state.send_links, action),
    bulk_assign_installers: bulkAssignInstallers(state.bulk_assign_installers, action)
  }
}

export default reducer
